import React, { useEffect, useRef } from "react";
import usePermission from "components/auth/usePermission";
import { Actions, Targets } from "constants/permissions";

/**
 * The widget binds its conversation-list dropdown to #aide-conversation-list once at mount, so
 * that element lives in the persistent shell (see MaplesTeesdale.js) and is reparented into this
 * slot while a page header is on screen — moving the node keeps the widget's bindings intact.
 */
const AideConversationListSlot = () => {
  const slotRef = useRef(null);
  const canUseAssistant = usePermission(Targets.Assistant, Actions.Access);

  useEffect(() => {
    if (!canUseAssistant) return;
    const host = document.getElementById("aide-conversation-list");
    const stash = host?.parentElement;
    const slot = slotRef.current;
    if (!host || !slot) return;
    slot.appendChild(host);
    return () => {
      // On a route swap the incoming slot's effect may claim the node before this cleanup
      // runs — only re-stash it if it is still ours, or we'd yank it out of the new header
      if (host.parentElement === slot) stash?.appendChild(host);
    };
  }, [canUseAssistant]);

  if (!canUseAssistant) return null;
  return <span className="aide-conversation-list-slot" ref={slotRef} />;
};

export default AideConversationListSlot;
